import { render, staticRenderFns } from "./user-listjg.vue?vue&type=template&id=2756b5cc&scoped=true&"
import script from "./user-listjg.vue?vue&type=script&lang=js&"
export * from "./user-listjg.vue?vue&type=script&lang=js&"
import style0 from "./user-listjg.vue?vue&type=style&index=0&id=2756b5cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2756b5cc",
  null
  
)

export default component.exports